import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';

import { MantineProvider } from '@mantine/core';
import { theme } from './theme';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { FinixEnvironmentProvider } from './FinixEnvironmentProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  },
});

const AppProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <MantineProvider defaultColorScheme='auto' theme={theme}>
      <QueryClientProvider client={queryClient}>
        <FinixEnvironmentProvider>{children}</FinixEnvironmentProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </MantineProvider>
  );
};

export default AppProvider;
